export const DEFAULT_TURNAROUND_TARGET_MINUTES = 30;

export type TurnaroundStatus = {
  minutes: number;
  overdue: boolean;
  label: string;
};

export const describeTurnaround = ({
  startedAt,
  targetMinutes,
  now,
}: {
  startedAt: string | null;
  targetMinutes: number | null;
  now: Date;
}): TurnaroundStatus | null => {
  if (!startedAt) return null;

  const started = new Date(startedAt);
  if (Number.isNaN(started.getTime())) return null;

  const target = targetMinutes ?? DEFAULT_TURNAROUND_TARGET_MINUTES;
  const dueAt = started.getTime() + target * 60_000;
  const remainingMinutes = Math.round((dueAt - now.getTime()) / 60_000);

  return remainingMinutes < 0
    ? {
        minutes: Math.abs(remainingMinutes),
        overdue: true,
        label: `Overdue ${Math.abs(remainingMinutes)} min`,
      }
    : {
        minutes: remainingMinutes,
        overdue: false,
        label: `${remainingMinutes} min to target`,
      };
};
